import gql from 'graphql-tag'

export const GET_COUPON_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
  ) {
    getCouponPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        validFrom
        validTo
        discount
        quantity
        usedQuantity
				banner
      }
    }
  }
`

export const GET_COUPON_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getCoupon (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      value
      validFrom
      validTo
      discount
      quantity
      usedQuantity
      autoUse
      banner
      firstOrder
      image
    }
  }
`
